import React, {Component} from 'react';
import styles from './MainPageCategoriesGrid.scss';
import Dropdown from 'react-dropdown';
import _ from 'lodash';
import Media from 'react-responsive';


export default class CategoryWithSelects extends Component {
  render() {
    const {params, name} = this.props;
    const selects = _.map(params, ({name}) => {
      const options = [name];
      return (
        <Dropdown key={`dropdown-cat-${name}`} options={options} value={name} placeholder={name} />
      );
    });
    return (
      <div className={styles.categoryWithSelects}>
        <Media query="(max-width: 1024px)">
          <h3 className={styles.categoryName}>{name}</h3>
        </Media>
        <Media query="(min-width: 1025px)">
          <h2 className={styles.categoryName}>{name}</h2>
        </Media>
        <div className={styles.selectsContainer} style={{width: '100%'}}>
          <span className="dropdown">
            {selects}
          </span>
        </div>
        <button className={styles.submitBtn}>Подобрать</button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/MainPage/elements/MainPageCategoryWithSelects.jsx
 **/